/* eslint-disable */
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {KTCard, KTCardBody} from '../../../components'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'
import {
  digitalPlanetGetSettings,
  selectDigitalPlanetSettings,
  selectDigitalPlanetSettingsLoading,
} from '../../../redux/slices/digitalplanetsettings.slice'
import {EfaturaSettingsForm} from './EfaturaSettingsForm'

function Index() {
  const dispatch = useDispatch()
  const settings = useSelector(selectDigitalPlanetSettings)
  const loading = useSelector(selectDigitalPlanetSettingsLoading)

  useEffect(() => {
    dispatch(digitalPlanetGetSettings())
  }, [dispatch])

  return (
    <>
      <PageTitle>E-Fatura Ayarları</PageTitle>
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='fw-bold'>Digital Planet Bağlantı Ayarları</h3>
          </div>
        </div>
        <KTCardBody>
          {loading && <ListLoading />}
          {!loading && <EfaturaSettingsForm settings={settings} />}
        </KTCardBody>
      </KTCard>
    </>
  )
}

export {Index}
